<template>
  <oxd-dialog class="orangehrm-dialog-modal" @update:show="$emit('close')">
    <div class="orangehrm-modal-header">
      <oxd-text type="card-title"
        >Justificatifs de la demande d’absence</oxd-text
      >
    </div>
    <oxd-divider />
    <oxd-form :loading="isLoading" @submit-valid="onSave">
      <oxd-text v-if="error" tag="p" class="attachment-error">{{
        error
      }}</oxd-text>
      <oxd-text v-if="!isLoading && attachments.length === 0" tag="p">
        Aucun justificatif déposé.
      </oxd-text>
      <div v-for="file in attachments" :key="file.id" class="attachment-row">
        <oxd-text tag="p">{{ file.filename }}</oxd-text>
        <oxd-button
          type="button"
          display-type="ghost"
          label="Télécharger"
          :disabled="isLoading"
          @click="download(file)"
        />
      </div>
      <template v-if="canUpload">
        <oxd-divider />
        <leave-attachment-input v-model="files" />
      </template>
      <oxd-divider />
      <oxd-form-actions>
        <oxd-button
          type="button"
          display-type="ghost"
          label="Fermer"
          @click="$emit('close')"
        />
        <oxd-button
          v-if="canUpload"
          type="submit"
          display-type="secondary"
          label="Déposer les justificatifs"
          :disabled="isLoading || !files.some(Boolean)"
        />
      </oxd-form-actions>
    </oxd-form>
  </oxd-dialog>
</template>

<script>
import {OxdDialog} from '@ohrm/oxd';
import {APIService} from '@/core/util/services/api.service';
import LeaveAttachmentInput from './LeaveAttachmentInput.vue';

export default {
  components: {
    'oxd-dialog': OxdDialog,
    'leave-attachment-input': LeaveAttachmentInput,
  },
  props: {
    id: {type: [Number, String], required: true},
    canUpload: {type: Boolean, default: false},
  },
  emits: ['close'],
  setup(props) {
    return {
      http: new APIService(
        window.appGlobal.baseUrl,
        `/api/v2/leave/leave-requests/${props.id}/attachments`,
      ),
    };
  },
  data() {
    return {isLoading: false, error: '', attachments: [], files: [null]};
  },
  beforeMount() {
    this.load();
  },
  methods: {
    async load() {
      this.isLoading = true;
      try {
        const response = await this.http.getAll();
        this.attachments = response.data.data;
      } catch (e) {
        this.error = 'Impossible de charger les justificatifs.';
      } finally {
        this.isLoading = false;
      }
    },
    async onSave() {
      this.isLoading = true;
      this.error = '';
      try {
        await this.http.create({attachments: this.files.filter(Boolean)});
        this.files = [null];
        this.$toast.success({
          title: 'Succès',
          message: 'Justificatifs déposés.',
        });
        await this.load();
      } catch (e) {
        this.error =
          'Le dépôt a échoué. Vérifiez le format et la taille des fichiers, puis réessayez.';
      } finally {
        this.isLoading = false;
      }
    },
    async download(file) {
      this.isLoading = true;
      this.error = '';
      try {
        const response = await this.http.get(file.id);
        const data = response.data.data;
        const bytes = Uint8Array.from(atob(data.base64), (char) =>
          char.charCodeAt(0),
        );
        const url = URL.createObjectURL(
          new Blob([bytes], {type: data.fileType}),
        );
        const link = document.createElement('a');
        link.href = url;
        link.download = data.filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
      } catch (e) {
        this.error = 'Impossible de télécharger ce justificatif.';
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.attachment-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  overflow-wrap: anywhere;
}
.attachment-error {
  color: #c62828;
}
</style>
